// 会员卡
export default {
    heard_title: "Membership Card",
    heard_btn: "Apply for membership Card",

    fl_keyword: "User account:",
    fp_keyword: "Mobile number/nickname",
    fl_code: "Membership card number:",
    fp_code: "cardCode",
    fl_startTime: "Card issuance time:",
    fp_startTime: "Please select a time",
    fl_status: "Membership card status:",
    op_all: "all",
    op_normal: "normal",
    op_frozen: "frozen",
    op_expired: "Expired",
    op_canceled: "Cancelled",

    tl_mobile: "User Account",
    tl_name: "User nickname",
    tl_levelName: "Membership Card Type",
    tl_code: "card number",
    tl_walletBalance: "Available Balance",
    tl_orderQuantity: "Order Quantity",
    tl_createTime: "Card issuance time",
    tl_status: "Membership Card Status",
    btn_viewUser: "View User",
    btn_recharge: "Recharge",
    btn_other: "Other operations",

    // 开卡弹出框
    dt_openCard: "Apply for membership card",
    dl_serialNo: "Chip ID:",
    dp_serialNo: "Please swipe to read",
    dl_mobile: "User Account",
    dp_mobile: "User Account",
    dl_code: "cardCode",
    dp_code: "card number",
    dl_validaDays: "Validity Period",
    dp_validaDays: "Please enter",
    dp_unit: "Days",
    dl_password: "Set password",
    dp_password: "Please enter",
    dp_confirmPassword: "Enter again",
    btn_sendCard: "Send Card",

    // 其他操作弹出框
    dt_operator: "Other operations",
    dl_nickName: "User Nickname:",
    dl_userMobile: "User account:",
    dl_memberCode: "memberCode:",
    dl_walletBalance: "Member Balance:",
    dl_levelName: "card type:",
    dl_createTime: "issuance time:",
    btn_rechargeCard: "Recharge",
    btn_loss: "Report Loss",
    btn_active: "Activate",
    btn_cancel: "Cancel",
    btn_editPassword: "Edit Password",
    btn_resetPassword: "Reset Password",

    // 修改密码弹出框
    dt_editPass: "Change Password",
    dp_paymentPassword: "Please enter your password",
    dp_comfirmPass: "Please enter your password again",

    // 注册弹框
    dt_register: "Register",
    dl_registerMobile: "Mobile number",
    dp_registerMobile: "Please enter your mobile number",
    dl_name: "Nickname",
    dp_nickName: "Please enter a nickname",
    btn_register: "register",

    // 提示
    em_codeRequire: "Please enter the card number",
    em_codeRule: "Please enter the 8-digit card number",
    em_mobileRule: "Please enter a valid mobile phone number",
    em_password: "The passwords entered twice do not match",
    em_passwordRange: "Please enter a six-digit password",
    sm_openCard: "Open card successfully",
    em_openCard: "Failed to open card",
    em_mobileStatus:
        "The phone number has not been registered, please register first",
    em_nickName: "Please enter a nickname",
    sm_register: "registered successfully",
    em_register: "Registration failed",
    sm_lost: "Successfully reported loss",
    em_lost: "Failed to report loss",
    sm_active: "Activated successfully",
    em_active: "Activation failed",
    msg_cancel:
        '"This operation will cancel the membership card, do you want to continue?',
    sm_cancel: "Cancellation successful",
    em_cancel: "Cancellation failed",
    im_cancel: "Cancelled",
    msg_confirm:
        "This operation will reset the membership card payment password, do you want to continue?",
    sm_resetPass: "Reset password successful",
    em_resetPass: "Failed to reset password",
    im_resetPass: "Cancelled",
    sm_editPass: "Password changed successfully",
    em_editPass: "Failed to change password",
    em_passRequire: "Password cannot be empty",

    ft_normal: "normal",
    ft_frozen: "frozen",
    ft_expired: "Expired",
    ft_canceled: "canceled"
};
